import { render, staticRenderFns } from "./MySchool.vue?vue&type=template&id=7d769e92&"
import script from "./MySchool.vue?vue&type=script&lang=js&"
export * from "./MySchool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports